<pdq-card variant="popover" color="white" class="boost-group" [formGroup]="groupForm">
  <div class="boost-group__header">
    <div class="boost-group__title">
      <pdq-heading element="h6">Boost Group {{ groupIndex + 1 }}</pdq-heading>
      <span class="boost-group__count">{{ badgesArray.length }} boosts</span>
    </div>
    <div class="boost-group__actions">
      <pdq-button
        icon="duplicate"
        size="small"
        variant="ghost"
        matTooltip="Duplicate group"
        matTooltipClass="pdq-mat-tooltip"
        (click)="duplicateRequested.emit(); $event.stopPropagation()"></pdq-button>
      @if (removable) {
        <pdq-button
          icon="trash"
          size="small"
          variant="ghost"
          iconColor="var(--error-default)"
          (click)="removeRequested.emit(); $event.stopPropagation()"></pdq-button>
      } @else {
        <pdq-icon class="boost-group__disabled-icon" icon="trash" size="small"></pdq-icon>
      }
      <pdq-button
        [icon]="expanded ? 'collapsing-arrow-up' : 'collaping-arrow-down'"
        size="small"
        variant="ghost"
        (click)="toggleExpanded(); $event.stopPropagation()"></pdq-button>
    </div>
  </div>

  @if (expanded) {
    <pdq-divider></pdq-divider>

    <div class="card-content" [formGroup]="groupForm.controls.productsInCart">
      <pdq-checkbox
        [formControl]="groupForm.controls.includeDigitalItems"
        label="Include digital items"
        secondaryLabel="Show boosts on digital items too"
        labelSize="small"></pdq-checkbox>

      <pdq-heading element="h7">Only show when cart includes:</pdq-heading>

      <pdq-radio-group [value]="currentMode" variant="segmented" labelSize="small" (onChange)="setMode($event)">
        @for (opt of productsInCartModeOptions; track opt.value) {
          <pdq-radio-button [value]="opt.value" [text]="opt.label"></pdq-radio-button>
        }
      </pdq-radio-group>

      @if (currentMode === 'smart') {
        <div class="smart-rules">
          <pdq-rules-dynamic-form
            [formGroup]="groupForm.controls.productsInCart"
            formArrayFieldName="rules"
            [rules]="rules"
            [entities]="entities"
            [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
          @if (
            groupForm.controls.productsInCart.errors?.['rulesRequired'] && groupForm.controls.productsInCart.touched
          ) {
            <span class="error-message">Add at least one rule to define which products this group applies to.</span>
          }
        </div>
      } @else {
        <div class="manual-products">
          <span class="manual-products__hint">Select specific products that this boost group applies to.</span>

          <div class="manual-products__header">
            <span class="manual-products__label">Trigger Products ({{ manualProducts.length }})</span>
            <pdq-button
              icon="Plus"
              label="Add Products"
              variant="secondary"
              size="small"
              [fitContent]="true"
              (click)="onAddProducts()"></pdq-button>
          </div>

          <pdq-product-list
            [products]="manualProductsForDisplay"
            [showSearch]="manualProducts.length > 4"
            [showRemove]="true"
            [showEdit]="true"
            [showExternalLink]="true"
            searchPlaceholder="Search..."
            emptyMessage="No products added yet"
            (remove)="onRemoveProduct($event.id)"
            (edit)="onEditProduct($event)"
            (externalLink)="onExternalLink($event)"></pdq-product-list>
          @if (
            groupForm.controls.productsInCart.errors?.['productsRequired'] && groupForm.controls.productsInCart.touched
          ) {
            <span class="error-message">Add at least one product to this group.</span>
          }
        </div>
      }
    </div>

    <div class="card-content">
      <div class="badges-header">
        <pdq-heading element="h7">Boosts ({{ badgesArray.length }})</pdq-heading>
        <pdq-dropdown
          #addBoostDropdown
          type="actionList"
          mode="secondary"
          buttonFontSize="13"
          placeholder="Add Boost"
          icon="Plus"
          iconSize="small"
          [options]="addBadgeOptions"
          [cta]="true"
          [showArrow]="false"
          (onChange)="onAddBadgeOption($event)"></pdq-dropdown>
      </div>

      @if (badgesArray.length === 0) {
        <div class="badges-empty">
          No boosts yet. Click
          <pdq-button
            class="badges-empty__cta"
            plain="true"
            size="small"
            variant="ghost-light"
            label="Add Boost"
            (onClick)="$event.stopPropagation(); addBoostDropdown.toggle()"></pdq-button>
          to create one
        </div>
      }

      <div class="badges-list" cdkDropList (cdkDropListDropped)="reorderBadges($event)">
        @for (badge of badgesArray.controls; track trackByBadgeId($index, badge); let i = $index) {
          <badge-editor
            cdkDrag
            [badgeForm]="badge"
            (removeRequested)="removeBadge(i)"
            (duplicateRequested)="duplicateBadge(i)"></badge-editor>
        }
      </div>
    </div>
  }
</pdq-card>
